import { Injectable } from '@angular/core';
import { ResponseCigoData } from '../shared/interfaces/cigo.interface';
import { GenericErrorType } from '../shared/enums';
@Injectable({
  providedIn: 'root'
})
export class DataClientService {

    constructor() { }

    private phoneNumber: string;
    private email: string;
    private isCheckTermsCMR: boolean;
    private streetName: string;
    private streetNumber: string;
    private addressWithoutNumber: boolean;
    private buildingName: string;
    private flatNumber: string;
    private urbanizationType: string;
    private urbanizationName: string;
    private blockNumber: string;
    private lotNumber: string;
    private sectorName: string;
    private workActivityType: string;
    private dateEntryWork: string;
    private companyName: string;
    private rucCompany: string;
    private profession: string;
    private housingType: string;
    private contryBirth: string;
    private nationality: string;
    private residenceCountry: string;
    private taxResidence: string;
    private isPEP: boolean;
    private isFATCA: boolean;
    private isECR: boolean;
    private isFisherman: boolean;
    private accountType: string;
    private isCheckTermsBFPE: boolean;
    private isJointAccount: boolean;
    private identificationTypeJoint: string;
    private indentificationNumberJoint: string;
    private phoneNumberJoint: string;
    private emailJoint: string;
    private streetNameJoint: string;
    private streetNumberJoint: string;
    private addressWithoutNumberJoint: boolean;
    private buildingNameJoint: string;
    private flatNumberJoint: string;
    private urbanizationTypeJoint: string;
    private urbanizationNameJoint: string;
    private blockNumberJoint: string;
    private lotNumberJoint: string;
    private sectorNameJoint: string;
    private workActivityTypeJoint: string;
    private dateEntryWorkJoint: string;
    private companyNameJoint: string;
    private rucCompanyJoint: string;
    private professionJoint: string;
    private housingTypeJoint: string;
    private contryBirthJoint: string;
    private nationalityJoint: string;
    private residenceCountryJoint: string;
    private taxResidenceJoint: string;
    private isPEPJoint: boolean;
    private isFATCAJoint: boolean;
    private isECRJoint: boolean;
    private isFishermanJoint: boolean;
    private idRequestManager: string;
    private numberRequestManager: string;
    private isForeignClient: boolean;
    private isForeignClientJoint: boolean;
    private currencyType: number;
    private openingDate: string;
    private responseCigo: ResponseCigoData;
    private responseCigoJoint: ResponseCigoData;
    private CCI: string;
    private accountNumber: string;
    private isCTS: boolean;
    private jointAccountWithoutInfo: boolean;
    private validationError = false;
    private canCreateProduct: boolean;
    private manualSignature = false;
    private clientManualSignature: boolean;
    private jointIsClient: boolean;
    private genericErrorType: GenericErrorType = GenericErrorType.DEFAULT_ERROR;

    public getGenericErrorType(): GenericErrorType {
        return this.genericErrorType;
    }

    public setGenericErrorType(genericErrorType: GenericErrorType): void {
        this.genericErrorType = genericErrorType;
    }

    public getValidationError(): boolean {
        return this.validationError;
    }

    public setValidationError(validationError: boolean) {
        this.validationError = validationError;
    }

    public getJointAccountWithoutInfo(): boolean {
        return this.jointAccountWithoutInfo;
    }

    public setJointAccountWithoutInfo(jointAccountWithoutInfo: boolean) {
        this.jointAccountWithoutInfo = jointAccountWithoutInfo;
    }

    public getStreetNameJoint(): string {
        return this.streetNameJoint;
    }

    public setStreetNameJoint(streetNameJoint: string): void {
        this.streetNameJoint = streetNameJoint;
    }

    public getStreetNumberJoint(): string {
        return this.streetNumberJoint;
    }

    public setStreetNumberJoint(streetNumberJoint: string): void {
        this.streetNumberJoint = streetNumberJoint;
    }

    public getBuildingNameJoint(): string {
        return this.buildingNameJoint;
    }

    public setBuildingNameJoint(buildingNameJoint: string): void {
        this.buildingNameJoint = buildingNameJoint;
    }

    public getFlatNumberJoint(): string {
        return this.flatNumberJoint;
    }

    public setFlatNumberJoint(flatNumberJoint: string): void {
        this.flatNumberJoint = flatNumberJoint;
    }

    public getUrbanizationTypeJoint(): string {
        return this.urbanizationTypeJoint;
    }

    public setUrbanizationTypeJoint(urbanizationTypeJoint: string): void {
        this.urbanizationTypeJoint = urbanizationTypeJoint;
    }

    public getUrbanizationNameJoint(): string {
        return this.urbanizationNameJoint;
    }

    public setUrbanizationNameJoint(urbanizationNameJoint: string): void {
        this.urbanizationNameJoint = urbanizationNameJoint;
    }

    public getBlockNumberJoint(): string {
        return this.blockNumberJoint;
    }

    public setBlockNumberJoint(blockNumberJoint: string): void {
        this.blockNumberJoint = blockNumberJoint;
    }

    public getLotNumberJoint(): string {
        return this.lotNumberJoint;
    }

    public setLotNumberJoint(lotNumberJoint: string): void {
        this.lotNumberJoint = lotNumberJoint;
    }

    public getSectorNameJoint(): string {
        return this.sectorNameJoint;
    }

    public setSectorNameJoint(sectorNameJoint: string): void {
        this.sectorNameJoint = sectorNameJoint;
    }

    public getWorkActivityTypeJoint(): string {
        return this.workActivityTypeJoint;
    }

    public setWorkActivityTypeJoint(workActivityTypeJoint: string): void {
        this.workActivityTypeJoint = workActivityTypeJoint;
    }

    public getDateEntryWorkJoint(): string {
        return this.dateEntryWorkJoint;
    }

    public setDateEntryWorkJoint(dateEntryWorkJoint: string): void {
        this.dateEntryWorkJoint = dateEntryWorkJoint;
    }

    public getNationalityJoint(): string {
        return this.nationalityJoint;
    }

    public setNationalityJoint(nationalityJoint: string): void {
        this.nationalityJoint = nationalityJoint;
    }

    public getResidenceCountryJoint(): string {
        return this.residenceCountryJoint;
    }

    public setResidenceCountryJoint(residenceCountryJoint: string): void {
        this.residenceCountryJoint = residenceCountryJoint;
    }

    public getTaxResidence(): string {
        return this.taxResidence;
    }

    public setTaxResidence(taxResidence: string): void {
        this.taxResidence = taxResidence;
    }

    public getTaxResidenceJoint(): string {
        return this.taxResidenceJoint;
    }

    public setTaxResidenceJoint(taxResidenceJoint: string): void {
        this.taxResidenceJoint = taxResidenceJoint;
    }

    public getIsPEPJoint(): boolean {
        return this.isPEPJoint;
    }

    public setIsPEPJoint(isPEPJoint: boolean): void {
        this.isPEPJoint = isPEPJoint;
    }

    public getIsFATCAJoint(): boolean {
        return this.isFATCAJoint;
    }

    public setIsFATCAJoint(isFATCAJoint: boolean): void {
        this.isFATCAJoint = isFATCAJoint;
    }

    public getIsECRJoint(): boolean {
        return this.isECRJoint;
    }

    public setIsECRJoint(isECRJoint: boolean): void {
        this.isECRJoint = isECRJoint;
    }

    public getIsFishermanJoint(): boolean {
        return this.isFishermanJoint;
    }

    public setIsFishermanJoint(isFishermanJoint: boolean): void {
        this.isFishermanJoint = isFishermanJoint;
    }


    public getIsECR(): boolean {
        return this.isECR;
    }

    public setIsECR(isECR: boolean): void {
        this.isECR = isECR;
    }

    public getIsFisherman(): boolean {
        return this.isFisherman;
    }

    public setIsFisherman(isFisherman: boolean): void {
        this.isFisherman = isFisherman;
    }

    public getIdentificationTypeJoint(): string {
        return this.identificationTypeJoint;
    }

    public setIdentificationTypeJoint(identificationTypeJoint: string): void {
        this.identificationTypeJoint = identificationTypeJoint;
    }

    public getIndentificationNumberJoint(): string {
        return this.indentificationNumberJoint;
    }

    public setIndentificationNumberJoint(indentificationNumberJoint: string): void {
        this.indentificationNumberJoint = indentificationNumberJoint;
    }

    public getPhoneNumberJoint(): string {
        return this.phoneNumberJoint;
    }

    public setPhoneNumberJoint(phoneNumberJoint: string): void {
        this.phoneNumberJoint = phoneNumberJoint;
    }

    public getEmailJoint(): string {
        return this.emailJoint;
    }

    public setEmailJoint(emailJoint: string): void {
        this.emailJoint = emailJoint;
    }

    public isIsJointAccount(): boolean {
    return this.isJointAccount;
    }

    public setIsJointAccount(isJointAccount: boolean): void {
    this.isJointAccount = isJointAccount;
    }

    public getAccountType(): string {
        return this.accountType;
    }

    public setAccountType(accountType: string): void {
        this.accountType = accountType;
    }

    public getPhoneNumber(): string {
        return this.phoneNumber;
    }

    public setPhoneNumber(phoneNumber: string): void {
        this.phoneNumber = phoneNumber;
    }

    public getEmail(): string {
        return this.email;
    }

    public setEmail(email: string): void {
        this.email = email;
    }

    public getStreetName(): string {
        return this.streetName;
    }

    public setStreetName(streetName: string): void {
        this.streetName = streetName;
    }

    public getStreetNumber(): string {
        return this.streetNumber;
    }

    public setStreetNumber(streetNumber: string): void {
        this.streetNumber = streetNumber;
    }

    public getBuildingName(): string {
        return this.buildingName;
    }

    public setBuildingName(buildingName: string): void {
        this.buildingName = buildingName;
    }

    public getFlatNumber(): string {
        return this.flatNumber;
    }

    public setFlatNumber(flatNumber: string): void {
        this.flatNumber = flatNumber;
    }

    public getUrbanizationType(): string {
        return this.urbanizationType;
    }

    public setUrbanizationType(urbanizationType: string): void {
        this.urbanizationType = urbanizationType;
    }

    public getUrbanizationName(): string {
        return this.urbanizationName;
    }

    public setUrbanizationName(urbanizationName: string): void {
        this.urbanizationName = urbanizationName;
    }

    public getBlockNumber(): string {
        return this.blockNumber;
    }

    public setBlockNumber(blockNumber: string): void {
        this.blockNumber = blockNumber;
    }

    public getLotNumber(): string {
        return this.lotNumber;
    }

    public setLotNumber(lotNumber: string): void {
        this.lotNumber = lotNumber;
    }

    public getSectorName(): string {
        return this.sectorName;
    }

    public setSectorName(sectorName: string): void {
        this.sectorName = sectorName;
    }

    public getWorkActivityType(): string {
        return this.workActivityType;
    }

    public setWorkActivityType(workActivityType: string): void {
        this.workActivityType = workActivityType;
    }

    public getDateEntryWork(): string {
        return this.dateEntryWork;
    }

    public setDateEntryWork(dateEntryWork: string): void {
        this.dateEntryWork = dateEntryWork;
    }

    public getCompanyName(): string {
        return this.companyName;
    }

    public setCompanyName(companyName: string): void {
        this.companyName = companyName;
    }

    public getRucCompany(): string {
        return this.rucCompany;
    }

    public setRucCompany(rucCompany: string): void {
        this.rucCompany = rucCompany;
    }

    public getProfession(): string {
        return this.profession;
    }

    public setProfession(profession: string): void {
        this.profession = profession;
    }

    public getCompanyNameJoint(): string {
        return this.companyNameJoint;
    }

    public setCompanyNameJoint(companyNameJoint: string): void {
        this.companyNameJoint = companyNameJoint;
    }

    public getRucCompanyJoint(): string {
        return this.rucCompanyJoint;
    }

    public setRucCompanyJoint(rucCompanyJoint: string): void {
        this.rucCompanyJoint = rucCompanyJoint;
    }

    public getProfessionJoint(): string {
        return this.professionJoint;
    }

    public setProfessionJoint(professionJoint: string): void {
        this.professionJoint = professionJoint;
    }

    public getNationality(): string {
        return this.nationality;
    }

    public setNationality(nationality: string): void {
        this.nationality = nationality;
    }

    public getResidenceCountry(): string {
        return this.residenceCountry;
    }

    public setResidenceCountry(residenceCountry: string): void {
        this.residenceCountry = residenceCountry;
    }

    public getCurrencyType(): number {
        return this.currencyType;
    }

    public setCurrencyType(currencyType: number): void {
        this.currencyType = currencyType;
    }

    public getIsPEP(): boolean {
        return this.isPEP;
    }

    public setIsPEP(isPEP: boolean): void {
        this.isPEP = isPEP;
    }

    public getIsFATCA(): boolean {
        return this.isFATCA;
    }

    public setIsFATCA(isFATCA: boolean): void {
        this.isFATCA = isFATCA;
    }

    public clientIsForeign(): boolean {
        return this.isForeignClient;
    }

    public setClientIsForeign(isForeignClient: boolean): void {
         this.isForeignClient = isForeignClient;
    }

    public jointIsForeign(): boolean {
        return this.isForeignClientJoint;
    }

    public setJointIsForeign(isForeignClientJoint: boolean): void {
         this.isForeignClientJoint = isForeignClientJoint;
    }

    public setCigoData(res: ResponseCigoData) {
        this.responseCigo = res;
    }

    public getCigoData() {
        return this.responseCigo;
    }

    public setCigoDataJoint(res: ResponseCigoData) {
        this.responseCigoJoint = res;
    }

    public getCigoDataJoint() {
        return this.responseCigoJoint;
    }

    public setCCI(CCI: string) {
        this.CCI = CCI;
    }

    public getCCI() {
        return this.CCI;
    }

    public setAccountNumber(AccountNumber: string) {
        this.accountNumber = AccountNumber;
    }

    public getAccountNumber() {
        return this.accountNumber;
    }

    public setIsCTS(isCTS: boolean) {
        this.isCTS = isCTS;
    }

    public isIsCTS() {
        return this.isCTS;
    }

    public setCanCreateProduct(can: boolean): void {
        this.canCreateProduct = can;
    }

    public getCanCreateProduct(): boolean {
        return this.canCreateProduct;
    }

    public setJointManualSignature(manualSignature: boolean): void {
        this.manualSignature = manualSignature;
    }

    public getJointManualSignature(): boolean {
        return this.manualSignature;
    }

    public setJointIsClient(jointIsClient: boolean) {
        this.jointIsClient = jointIsClient;
    }

    public getJointIsClient() {
        return this.jointIsClient;
    }
}
